import createKeyFactory, { KEYS } from 'utils/createKeyFactory';

const notificationsFactory = {
  ...createKeyFactory([KEYS.NOTIFICATIONS]),
  unread: () => [...notificationsFactory.all(), 'UNREAD'],
  params: () => [...notificationsFactory.all(), 'PARAMS'],
  userParams: () => [...notificationsFactory.all(), 'USER_PARAMS'],
};

export default notificationsFactory;
